import './App.css';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './components/about';
import Challenge from './components/challenge';
import Footer from './components/footer';
import HighlightOfTheDay from './components/highlight';
import Navbar from './components/navbar';
import RateMyDay from './components/table';
import Table2 from './components/table2';
import Table3 from './components/table3';

export default function App() {
  ReactGA.initialize('G-LJPT7V2ZF1');

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);
  return (
    <Router>
      {' '}
      {/* Remove basename as it's not needed for Netlify */}
      <div className="pageBody">
        <Navbar />
        <div>
          <Routes>
            {/* Define your routes here */}
            <Route exact path="/" element={<RateMyDay />} />
            <Route path="/table2" element={<Table2 />} />
            <Route path="/table3" element={<Table3 />} />
            <Route
              path="/highlight-of-the-day"
              element={<HighlightOfTheDay />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/challenge" element={<Challenge />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}
